"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ROOT_NODE_NAME = exports.DEFAULT_INITIAL_VERSION = void 0;
exports.DEFAULT_INITIAL_VERSION = '0.0.0';
exports.DEFAULT_ROOT_NODE_NAME = 'root-node';
//# sourceMappingURL=types.js.map